import * as React from 'react';

const EmptyStringComponent: React.FC = () => (
	<span aria-hidden="true">&nbsp;&nbsp;</span>
);

export default EmptyStringComponent;
